import React from 'react'
import {Grid, Row, Col, Body} from '@mcafee/pegasus'

export default function McAfeeFooter() {
  return (
    
        <>
        <Row className="bg-white footer-border"> </Row>
        <Grid fluid className="pb-48" style={{maxWidth: 1340}}>
          <Row className="px-12">
              <Col xs={12} sm={10} md={10} lg={11}>
                  <Body level="5" className="text-tertiary">
                  <p>McAfee and the McAfee logo are trademarks or registered trademarks of McAfee, LLC or its subsidiaries in the United States and other countries. Other names and brands
                  may be claimed as the property of others. Copyright ©{new Date().getFullYear()} McAfee, LLC</p>
                  </Body>
              </Col>
          </Row>
          
       </Grid></>
        
    
  )
}
